import { Button, ButtonRow, Heading, Link, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import type { TwoFactorAuthenticationType } from '../../../../common/enums/twoFactorAuthenticationType';
import { LoginMfaHelpFooter } from '../../elements/LoginMfaHelpFooter';
import { MfaMethodSelector } from './MfaMethodSelector';

interface IChooseMfaMethodProps {
    goBack: () => void;
    goToNextStep: () => void;
    isSetupAtLogin?: boolean;
    mfaType: TwoFactorAuthenticationType | undefined;
    onChangeMfaType: (mfaType: TwoFactorAuthenticationType) => void;
    skipStep: () => void;
}

export function ChooseMfaMethod(props: IChooseMfaMethodProps) {
    const translate = getSelectedLanguage();

    return (
        <>
            <Heading>{props.isSetupAtLogin ? 'Tweestapsverificatie instellen' : 'Account activeren'}</Heading>
            <Text>
                Tweestapsverificatie is verplicht. Het instellen is zo gedaan.
                <br />
                <br />
                Kies de methode die je gaat gebruiken.
            </Text>
            <MfaMethodSelector
                onChange={(mfaType) => props.onChangeMfaType(mfaType)}
                value={props.mfaType}
            />
            <ButtonRow>
                <Button
                    color="secondary"
                    onClick={() => props.goToNextStep()}
                    width="full"
                >
                    {translate.common.next}
                </Button>
                <Button
                    color="secondary"
                    onClick={() => props.goBack()}
                    variant="outline"
                    width="full"
                >
                    {translate.common.previous}
                </Button>
            </ButtonRow>
            {props.isSetupAtLogin && (
                <Text
                    size="sm"
                    textAlign="center"
                >
                    <Link
                        color="minimal"
                        fontWeight="normal"
                        href="https://www.ksyos.nl/hardware-token-voor-2fa-bestellen/"
                        openInNewTab={true}
                        variant="externalLink"
                    >
                        Ik wil een hardware token bestellen
                    </Link>
                </Text>
            )}
            <LoginMfaHelpFooter instructionsVideo="both" />
        </>
    );
}
